export default async function updateChamadosolucao(chamadoId, solucao) {
    try {
        // Recupera informações da sessão do usuário
        const userSession = JSON.parse(sessionStorage.getItem('user'));

        if (!userSession || !userSession.token || !userSession.id || !userSession.name) {
            throw new Error("Dados insuficientes no sessionStorage.");
        }

        // Extração de dados do sessionStorage
        const { token, id: id_user_final, name: nome_user_final } = userSession;

        if (!chamadoId || !solucao) {
            throw new Error("ID do chamado e solução são obrigatórios.");
        }

        // Faz a requisição para a API
        const response = await fetch(`${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/chamados/${encodeURIComponent(chamadoId)}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify({ solucao, id_user_final, nome_user_final }),
        });

        // Verifica a resposta da API
        if (!response.ok) {
            throw new Error(`Erro ao atualizar chamado: ${response.statusText}`);
        }

        const data = await response.json();

        if (!data || !data.chamado) {
            throw new Error("Resposta inválida da API ou chamado não encontrado.");
        }

        // Retorna os dados do chamado atualizado
        return data;
    } catch (error) {
        console.error("Erro ao atualizar chamado:", error.message);
        return { chamado: null, error: error.message }; // Retorna um objeto padrão em caso de erro
    }
}
